<template>
  <label class="checkbox" :class="{ 'checkbox--readonly': readonly, 'checkbox--single': single }">
    <span class="checkbox__text">{{ label }}</span>
    <input
        type="checkbox"
        :checked="value"
        @change="$emit('change', $event.target.checked)"
        :name="name"
    />
    <span class="checkbox__checkmark"></span>
  </label>
</template>

<script>
export default {
  name: 'AppCheckbox',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: [String, Boolean],
    label: String,
    name: String,
    readonly: Boolean,
    single: Boolean
  },
}
</script>

<style lang="sass">
.checkbox
  display: inline-flex
  align-items: center
  position: relative
  padding-left: 25px
  cursor: pointer
  user-select: none

  input
    +visually-hidden

    &:checked ~ .checkbox__checkmark
      border-color: $color-theme
      background-color: $color-theme

      &:after
        content: ""

.checkbox--table
  padding-left: 0

  .checkbox__checkmark
    position: static

    &:after
      content: ""
      background-color: transparent

  input
    &:checked ~ .checkbox__checkmark
      &:after
        background-color: $color-theme

.checkbox--many
  margin-right: 30px

  &:last-child
    margin-right: 0

.checkbox--readonly
  pointer-events: none

  .checkbox__checkmark
    border-color: #ff9416

  input:checked ~ .checkbox__checkmark
    border-color: #ff9416
    background-color: #ff9416

    &:after
      background-color: #ff9416

.checkbox--single
  padding-left: 0

  .checkbox__checkmark
    position: static

.checkbox__checkmark
  display: flex
  align-items: center
  justify-content: center
  position: absolute
  top: 1px
  left: 0
  width: 16px
  height: 16px
  background-color: #fff
  border: 1px solid $color-border
  box-sizing: border-box
  border-radius: 4px

  &:after
    content: none
    width: 8px
    height: 6px
    background-image: url("~@/assets/img/checkbox-checked.svg")
    background-repeat: no-repeat

.checkbox__text
  font-size: 13px
  font-weight: 400
  line-height: 20px
  color: $color-text-base

  a
    color: $color-theme
    text-decoration: none

    &:hover
      text-decoration: underline
</style>
